import $ from 'jquery';

class Solc {
  constructor() {
      //this.chartOne = this.chartOne.bind(this);
  }

  init() {
      this.bindEvents();
  }

  bindEvents() {
    $(document).ready(() => {
        if (document.URL.toLowerCase().includes('solc') || document.URL.includes('state-of-lung-cancer')) {
        // identify page's state full name (dash format ex: new-york)
        //SOTC Button dynamic change:
        let urlArr = document.URL.split(document.domain); // WITHOUT domain
        let relativeURL;
        let stateName;
        [, relativeURL] = urlArr;
        let relativeSplitArr = relativeURL.split('/research/state-of-lung-cancer/states/');
        [, stateName] = relativeSplitArr;
        let sotcURL = `/research/sotc/state-grades/${stateName}`;
        document.getElementById('solcToSotc').setAttribute('href', sotcURL);

        const urlKey = {
            alabama: 'https://lung.box.com/s/9xynntic686o0ejem1cuapw04witgeng',
            alaska: 'https://lung.box.com/s/owpmczwy2s1c8d94crf199fa704l2y90',
            arizona: 'https://lung.box.com/s/0cp43id033sz742t1rngqch93u5kbqk1',
            arkansas: 'https://lung.box.com/s/z8kmwt41nfunw5au0c4h6ruuine8f5nh',
            california: 'https://lung.box.com/s/pw0mtk53lvocrcks6hh93n3e4msittm7',
            colorado: 'https://lung.box.com/s/b5lfcmgyl7q71rnpe8h47yveooq97k23',
            connecticut: 'https://lung.box.com/s/64aiy1e0s4wdq3k1catc5mdsa5dfqrti',
            delaware: 'https://lung.box.com/s/vu8ebnyjq8zff6f1dfhj2r4tlxpsh1p8',
            'district-of-columbia': 'https://lung.box.com/s/ni1l1v76z643i8h1xwqx25jk674zcmlw',
            florida: 'https://lung.box.com/s/v1gzclxrg5ki2odmzfepaj8v7jrzo7v1',
            georgia: 'https://lung.box.com/s/tjvbdcc77uxyrjbi6cfgouqkpo9ghohu',
            hawaii: 'https://lung.box.com/s/x1psrx8dq2huxcb8xwphxa573cswy4sr',
            idaho: 'https://lung.box.com/s/b342g6tuhlp02xbbuthigv5j5vavv6gp',
            illinois: 'https://lung.box.com/s/quhq7eng9ynbrqxdnvkyww8ryzky2f6w',
            indiana: 'https://lung.box.com/s/5cfn6ybx1i75wv3okoxbk5o4s54oobdh',
            iowa: 'https://lung.box.com/s/f55regt770lu5j4ggfuue34ocj3xmmb8',
            kansas: 'https://lung.box.com/s/4vy9y13216noq69fu5yt51q7kystaqgi',
            kentucky: 'https://lung.box.com/s/abjdakv10lxinpnhlnl38ryrnq5imczi',
            louisiana: 'https://lung.box.com/s/k999hpe8i8z6ssroo8cith4gp5qk4az9',
            maine: 'https://lung.box.com/s/egxg7nvj3ti9w0i2jfwbx0fawym48u6t',
            maryland: 'https://lung.box.com/s/5q9jrkhijmp8o7r7m72ltn3pm183e7lo',
            massachusetts: 'https://lung.box.com/s/egq115r57ncxh9litlj62an00707wzo4',
            michigan: 'https://lung.box.com/s/ssj0aexhmm2j6wkawbvma11ccy81uerd',
            minnesota: 'https://lung.box.com/s/9kle0bh64lwsniaob5bmf27a94tdzvl6',
            mississippi: 'https://lung.box.com/s/9x5zb5ud0jr0zc2alydjo800qr66gmui',
            missouri: 'https://lung.box.com/s/imxp1gnnd2e7k2drybiq0bvsft4yxhbe',
            montana: 'https://lung.box.com/s/4t735cxy2g53bqn8avd256a3j74xdjd4',
            nebraska: 'https://lung.box.com/s/r2i7kbt6728j7hcpqisjp6q4eu6hpoyh',
            nevada: 'https://lung.box.com/s/xjxt09lios28kq4b4ng71ywbauz0dhii',
            'new-hampshire': 'https://lung.box.com/s/x8k5yqigkp4yfb94dfkihcf58l6b9j3q',
            'new-jersey': 'https://lung.box.com/s/ms977cjz1609x3yns19k1wko0bt9nfw6',
            'new-mexico': 'https://lung.box.com/s/5zougd5gtj3mx3gcrf6kgtbyah76ber3',
            'new-york': 'https://lung.box.com/s/w7fgpoprqpf96cqu7ulwlr4tpv5ht12w',
            'north-carolina': 'https://lung.box.com/s/neenzed726htns48jo9kpz4nolhdx2n6',
            'north-dakota': 'https://lung.box.com/s/4mq58tgc4hxwdrmxzqxlwvbvp9u996yp',
            ohio: 'https://lung.box.com/s/aqdazbjv2x4y2avennab11i446wez2zf',
            oklahoma: 'https://lung.box.com/s/qb3ps9yzj3sqh7ay34oclvoalpzhtxhy',
            oregon: 'https://lung.box.com/s/j06d7gaq8czczlrk6gr7v8rwku3otich',
            pennsylvania: 'https://lung.box.com/s/tye7t8y31dd9lgijuy9zs2iuqi6zjpzl',
            'rhode-island': 'https://lung.box.com/s/007ota8w713c0vwst1quwg5jezyoqdqr',
            'south-carolina': 'https://lung.box.com/s/xskavivehvci0hh3887u3wepeeyv8qdt',
            'south-dakota': 'https://lung.box.com/s/yb36hcrlbne4vnur3h4ke3g6rpc5fef9',
            tennessee: 'https://lung.box.com/s/x90536l4tyfrn2orb9b5covs3efzh4j6',
            texas: 'https://lung.box.com/s/gydv37d4qrx4rqwkg8ip5uvngykno1kt',
            utah: 'https://lung.box.com/s/qemelhvjbfwnead3jkovp4e6xwagfbkl',
            vermont: 'https://lung.box.com/s/2h48cytjy1z9tpndcm9sij87oqfb2tpu',
            virginia: 'https://lung.box.com/s/4u2tlgycy2ebibty6v3ahzn97tll1vx1',
            washington: 'https://lung.box.com/s/5s3u9qlpzikdy5p8nzmhzsffc7zp5e9t',
            'west-virginia': 'https://lung.box.com/s/q7qjy7bdszd0kkzze2csgv7vtc2ipf3y',
            wisconsin: 'https://lung.box.com/s/r9kup9wfc5vh7su885bxtu4x41l18b0z',
            wyoming: 'https://lung.box.com/s/lsibjbtv0et7553fdgwjsior99gty0kc'
        };
        let infographicURL = urlKey[stateName];
        document.getElementById('solcInfographic').setAttribute('href', infographicURL);

        let currentStateAbbrev = stateName;  // CHANGING TO FULL STATE NAME INSTEAD OF ABBREVIATION
        if (!currentStateAbbrev) {
            const errMsg = document.createElement('p');
            const msgTxt = document.createTextNode('No location found. Please enable cookies for this feature. Setting currentStateAbbrev to \'Nation\'');
            errMsg.appendChild(msgTxt);
            document.getElementById('reportCardTable').insertAdjacentElement('beforebegin', errMsg);
            currentStateAbbrev = 'Nation';
        }
      } // end if statement url include solc
    }); // end document.ready
  }
}

export default Solc;
